import { isObject, isString } from '@/utils/is';
import type { CancelToken, CancelTokenSource } from 'axios';
import axios from 'axios';

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

export function joinTimestamp<T extends boolean>(join: boolean, restful: T): T extends true ? string : object;

export function joinTimestamp(join: boolean, restful = false): string | object {
  if (!join) {
    return restful ? '' : {};
  }
  const now = new Date().getTime();
  if (restful) {
    return `?_t=${now}`;
  }
  return { _t: now };
}

/**
 * @description: Format request parameter time
 */
export function formatRequestDate(params: Recordable) {
  if (Object.prototype.toString.call(params) !== '[object Object]') {
    return;
  }

  for (const key in params) {
    if (params[key] && params[key]._isAMomentObject) {
      params[key] = params[key].format(DATE_TIME_FORMAT);
    }
    if (isString(key)) {
      const value = params[key];
      if (value) {
        try {
          params[key] = isString(value) ? value.trim() : value;
        } catch (error) {
          throw new Error(error as string);
        }
      }
    }
    if (isObject(params[key])) {
      formatRequestDate(params[key]);
    }
  }
}

export class CancelTokenManager {
  private cancelTokenSource: CancelTokenSource | null = null;

  createCancelToken() {
    this.cancelTokenSource = axios.CancelToken.source();
    console.log('CancelTokenManager', this.cancelTokenSource);
    return this.cancelTokenSource.token;
  }

  cancelRequest(message?: string) {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel(message || 'Request canceled');
      this.cancelTokenSource = null;
    }
  }
}

// 判断请求是否被取消了
export async function isRequestCanceled(cancelToekn?: CancelToken): Promise<boolean> {
  if (!cancelToekn) return false;
  let isCanceled = false;
  // 这里的promise分为两种情况  可能当前还处于pending状态，也可能已经被取消了
  // 执行到响应错误拦截器 代表当前的请求已经执行完毕不管是正常的执行还是取消导致的请求中断
  cancelToekn.promise.then(() => {
    isCanceled = true;
  });
  // 等待下一个事件循环，否则isCanceled拿不到结果
  await new Promise((resolve) => setTimeout(resolve, 0));
  return isCanceled;
}
